<template>
	<div class="bar person">
		<i class="ss-user ss-glyphish-filled"></i>
		<h4>{{ person.name }}</h4>
	</div>
</template>

<script>

export default {
	props: ['person']
}
</script>

<style lang="scss">
.bar.person {
	background: #fff;
	border: 1px solid #D2D2D2;
	cursor: pointer;
	position: relative;
	i {
		color: black;
		position: absolute;
		top: 2px;
		left: 8px;
	}
	h4 {
		padding-left: 30px;
		display: inline-block;
		font-weight: 600 !important;
		margin-top: 0px;
		margin-bottom: 0px;
		font-size: 14px;
		line-height: 32px;
		color: #0C2D39;
		font-weight: 400;
		margin-left: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Person.vue